module.exports = __webpack_public_path__ + "static/media/S1_00013.14a0ff80.jpg";